// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aFTB","content":"styles_content__27Oax"};